import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

export const HRVPage = () => {
  return (
    <Layout>
      <PageHero
        title="Pulsuhr-Analyse (HRV): Einblicke in Stress und Regeneration"
        subtitle="Wir messen Ihre Herzratenvariabilität, um Ihr Stresslevel und Ihre Regenerationsfähigkeit zu beurteilen."
        backgroundImage="/images/Hörtest.webp"
        ctaText="HRV-Analyse buchen"
      />

      <ContentSection
        title="Mehr über Ihr körpereigenes Gleichgewicht erfahren"
        content="Die Herzratenvariabilität (HRV) gibt Aufschluss über die Regulationsfähigkeit Ihres autonomen Nervensystems. Eine gute HRV deutet auf eine hohe Anpassungsfähigkeit und Stressresistenz hin. Mit einer speziellen Pulsuhr analysieren wir Ihre HRV über einen bestimmten Zeitraum und geben Ihnen wertvolle Hinweise für Ihr Wohlbefinden und Ihre Leistungsfähigkeit."
        image="/images/Hörtest.webp"
        backgroundColor="white"
      />

      <SEOContent
        title="Stresslevel-Analyse (HRV) in Diez"
        content="Die Gemeinschaftspraxis Dres. von Bergh bietet die Pulsuhr-Analyse (HRV) zur Beurteilung von Stress und Regeneration an."
      />

      <CTASection
        title="Möchten Sie Ihr Stresslevel und Ihre Regenerationsfähigkeit verstehen?"
        subtitle="Vereinbaren Sie einen Termin für die HRV-Analyse."
        buttonText="Jetzt Termin anfragen"
      />
    </Layout>
  );
};

export default HRVPage;
